import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent {
  competencies: any[] = [];
  apiUrl: string = environment.apiUrl;
  httpOptions: any;
  employeeCompetenciesRequestedData: any;
  buttonTitle = '';

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { action: string, requestData: any },
    private http: HttpClient
  ) {
    this.employeeCompetenciesRequestedData = data.requestData;
    this.httpOptions = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token')
      })
    };

    this.buttonTitle = data.action === 'decline' ? 'proceed' : data.action;
  }

  ngOnInit(): void {
    this.fetchCompetencyData();
  }

  // Fetch competency data from the API
  fetchCompetencyData(): void {
    this.http.get<any>(`${this.apiUrl}Competency/GetNoCompetencyEmployeeIds?search=%20&from=0&size=10`, this.httpOptions)
      .subscribe((response: HttpResponse<any>) => {
        if (response.body && response.body.data) {
          this.competencies = response.body.data.map(item => ({
            employeeCompetencyRequestedId: item.employeeCompetencyRequestedId,
          }));
        }
      }, error => {
        console.error('Error fetching competency data:', error);
      });
  }

// In confirm-dialog.component.ts
onConfirm(): void {
  if (!this.employeeCompetenciesRequestedData || this.employeeCompetenciesRequestedData.EmployeeId === 0) {
    alert('Invalid Employee ID or data. Please try again.');
    return;
  }

  const payload = {
    employeeCompetencyRequestId: this.employeeCompetenciesRequestedData.employeeCompetencyRequestedId,
  };

  if (this.data.action === 'accept') {
    
    // Handle approve action
    this.http.post(`${this.apiUrl}ManagerCompetencyAndSubCompetency/Approve?employeeCompetencyRequestIds=${payload.employeeCompetencyRequestId}`, this.httpOptions)
      .subscribe((response) => {
        console.log('Competency approved successfully', response);
        this.dialogRef.close(true);      
      }, error => {
        console.error('Error approving competency:', error);
        alert('An error occurred while approving the competency. Please try again.');
      });
  } else if (this.data.action === 'decline') {
    
    // Handle reject action
    this.http.post(`${this.apiUrl}ManagerCompetencyAndSubCompetency/Reject?employeeCompetencyRequestIds=${payload.employeeCompetencyRequestId}`, this.httpOptions)
      .subscribe((response) => {
        console.log('Competency rejected successfully', response);
        this.dialogRef.close(true);
      }, error => {
        console.error('Error rejecting competency:', error);
        alert('An error occurred while rejecting the competency. Please try again.');
      });
  }
}


  // Close dialog when Cancel button is clicked
  onCancel(): void {
    this.dialogRef.close(false);
  }
  reloadPage(): void {
    location.reload();  // Reload the current page
  }
}

